import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Home, 
  Layers, 
  Droplets, 
  Zap, 
  Paintbrush, 
  Square, 
  Wind, 
  Building,
  Hammer,
  ArrowRight,
  Check
} from 'lucide-react';

export default function ServicesPage() {
  const services = [
    {
      id: 'hvac',
      icon: Wind,
      title: 'AC Install & Repair',
      tagline: 'Cool in summer. Warm in winter.',
      description: 'Texas weather is no joke. We install, replace, and service HVAC systems to keep your home comfortable year-round.',
      services: [
        'Install, replace, service all major brands',
        'Ductwork repair & replacement',
        'Sizing & central AC',
        'Mini-split systems',
        'Thermostats',
        'Post-renovation integration',
      ],
      image: 'https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxIVkFDJTIwZHVjdHdvcmslMjBhaXIlMjBjb25kaXRpb25pbmclMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzc0NDUxMzE4fDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'carpentry',
      icon: Hammer,
      title: 'Carpentry',
      tagline: 'Craftsmanship that shows',
      description: 'From custom trim to finish carpentry, our skilled carpenters bring precision and artistry to every project.',
      services: [
        'Custom trim & built-ins',
        'Finish carpentry',
        'New decks',
        'Cabinet installation',
        'Crown molding, doors, windows',
      ],
      image: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/5b66qqme_1000184564.jpg',
      image2: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/tluuw916_1000184570.jpg',
    },
    {
      id: 'electrical',
      icon: Zap,
      title: 'Electrical',
      tagline: 'Safe. Smart. Up to code.',
      description: 'Modern homes need modern electrical. Our licensed electricians handle everything from panels to EV chargers.',
      services: [
        'Wiring up to code',
        'New panels & circuits',
        'Lighting & fixture work',
        'Permit-pulled & inspections',
        'EV charger installation',
      ],
      image: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/cwv69y4r_1000184595.jpg',
    },
    {
      id: 'flooring',
      icon: Layers,
      title: 'Flooring',
      tagline: 'The foundation of every room',
      description: 'Beautiful floors transform a space. From hardwood to tile to luxury vinyl, we handle every detail—from subfloor prep to the final finish.',
      services: [
        'Hardwood & engineered wood',
        'Tile installation',
        'Luxury vinyl plank (LVP)',
        'Laminate & carpet',
        'Subfloor prep & transitions',
        'Custom patterns',
      ],
      image: 'https://images.pexels.com/photos/1388944/floor-flooring-hand-man-1388944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    },
    {
      id: 'renovation',
      icon: Building,
      title: 'Home Renovation',
      tagline: 'Your vision. Our expertise.',
      description: 'From single-room remodels to complete home transformations, we bring it all together under one project manager.',
      services: [
        'Kitchen remodels',
        'Bathroom renovations',
        'Full additions',
        'Basement & garage conversions',
        'Commercial tenant improvements',
      ],
      image: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/mx4uyftl_1000184558.jpg',
      image2: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/g5l7hni1_1000184586.jpg',
    },
    {
      id: 'painting',
      icon: Paintbrush,
      title: 'Painting',
      tagline: 'The finish that changes everything',
      description: 'A fresh coat of paint can make a room feel brand new. We prep, prime, and paint with care—no drips, no shortcuts.',
      services: [
        'Interior & exterior painting',
        'Proper prep, primer, sanding',
        'Trim work',
        'Cabinet painting & refinishing',
        'Deck & fence staining',
        'Texture matching',
      ],
      image: 'https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/g404ppk0_1000184592.jpg',
    },
    {
      id: 'plumbing',
      icon: Droplets,
      title: 'Plumbing',
      tagline: 'Reliable water, reliably done',
      description: 'From dripping faucets to full-home re-pipes, our licensed plumbers handle it all—cleanly, correctly, and with minimal disruption.',
      services: [
        'Dripping faucet to full re-pipes',
        'Water heater install/replacement',
        'Fixture & faucet installation',
        'Kitchen/bath integration',
        'Drain cleaning',
      ],
      image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=80&w=800',
    },
    {
      id: 'roofing',
      icon: Home,
      title: 'Roofing',
      tagline: 'Protection starts at the top',
      description: 'Your roof is your home\'s first line of defense. We deliver quality roofing that lasts, backed by thorough inspections and honest assessments.',
      services: [
        'Hail damage assessment',
        'Full replacement & new installs',
        'Asphalt shingles & metal roofing',
        'Flat/TPO systems',
        'Written warranty',
        'Post-install inspection',
      ],
      image: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?q=80&w=800',
    },
    {
      id: 'sheetrock',
      icon: Square,
      title: 'Sheetrock / Drywall',
      tagline: 'Walls that look like they were always there',
      description: 'Whether you\'re repairing damage or finishing a new space, our drywall work blends seamlessly.',
      services: [
        'Patching holes',
        'Hanging & finishing rooms',
        'Texture matching (orange peel, knockdown, smooth)',
        'Water damage replacement',
        'Soundproofing upgrades',
        'Garage & basement finishing',
      ],
      image: 'https://images.pexels.com/photos/4981812/pexels-photo-4981812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    },
  ];

  return (
    <main data-testid="services-page" className="pt-20">
      {/* Hero */}
      <section className="bg-navy grain-overlay py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-copper text-xs font-inter uppercase tracking-widest">
              Services
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white mt-4 leading-tight">
              Every Trade. One Standard.
            </h1>
            <p className="text-white/70 font-inter text-lg mt-6 leading-relaxed">
              Whether you need one repair or a complete renovation, C.A.B brings the same attention to detail and commitment to your timeline across every service we offer. No excuses.
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-24 bg-off-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {services.map((service, index) => (
              <div 
                key={service.id}
                id={service.id}
                className={`grid lg:grid-cols-2 gap-12 items-center`}
                data-testid={`service-section-${service.id}`}
              >
                {/* Image(s) */}
                <div className={`overflow-hidden ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  {service.image2 ? (
                    <div className="grid grid-cols-2 gap-3">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-60 lg:h-[400px] object-cover"
                      />
                      <img
                        src={service.image2}
                        alt={`${service.title} - additional`}
                        className="w-full h-60 lg:h-[400px] object-cover"
                      />
                    </div>
                  ) : (
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-80 lg:h-[500px] object-cover"
                    />
                  )}
                </div>

                {/* Content */}
                <div className={`space-y-6 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-copper/10 flex items-center justify-center">
                      <service.icon className="w-6 h-6 text-copper" />
                    </div>
                  </div>
                  
                  <div>
                    <h2 className="text-3xl md:text-4xl font-playfair font-bold text-navy">
                      {service.title}
                    </h2>
                    <p className="text-copper font-inter text-sm mt-1">
                      {service.tagline}
                    </p>
                  </div>
                  
                  <p className="text-navy/70 font-inter leading-relaxed">
                    {service.description}
                  </p>

                  <div className="space-y-3">
                    <p className="font-inter font-semibold text-navy text-sm uppercase tracking-wide">
                      Services include:
                    </p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {service.services.map((item, i) => (
                        <li key={i} className="flex items-center space-x-2">
                          <Check className="w-4 h-4 text-copper flex-shrink-0" />
                          <span className="text-navy/70 font-inter text-sm">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link to="/contact">
                    <Button 
                      className="bg-navy hover:bg-navy/90 text-white px-8 py-6 text-xs font-bold uppercase tracking-widest group mt-4"
                    >
                      Get a Quote
                      <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-copper">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-white">
            Not sure which service you need?
          </h2>
          <p className="text-white/80 font-inter mt-4">
            No problem. Tell us about your project and we'll help you figure it out.
          </p>
          <Link to="/contact" className="inline-block mt-8">
            <Button 
              data-testid="services-cta"
              className="bg-white text-copper hover:bg-white/90 px-8 py-6 text-xs font-bold uppercase tracking-widest group"
            >
              Book My Estimate Now
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
          <p className="text-white/60 font-inter text-sm mt-6">
            $49.99 (deposit will be applied to invoice after booking)
          </p>
        </div>
      </section>
    </main>
  );
}
